import { Component, Input, Output, EventEmitter } from '@angular/core';

import { StorageManagerService } from 'src/app/storage/services/storage-manager.service';
import { ComponentsService } from '../../services/components.service';
import { StorageUtilsService } from 'src/app/storage/services/storage-utils.service';

@Component({
    selector: 'template-editor-file-entry',
    templateUrl: './file-entry.component.html',
    styleUrls: ['./file-entry.component.scss'],
    standalone: false
})
export class FileEntryComponent {

  @Input() fileType: string;
  @Input() entry: any = {};
  @Output()
  public removeEvent = new EventEmitter<any>();
  @Input() showGripHandle: boolean;

  private STREAMLINE_URI = /^streamline:(.+)/;
  private DEFAULT_URI = 'https://s3.amazonaws.com/Rise-Images/UI/';

  constructor(private storageUtilsService: StorageUtilsService,
    public storageManagerService: StorageManagerService,
    private componentsService: ComponentsService
  ) { }

  getFileName() {
    return this.entry ? this.storageUtilsService.fileNameOf(this.entry.file) : '';
  }

  getStoragePath() {
    return this.entry ? this.storageUtilsService.parseStoragePath(this.entry.file) : '';
  }

  getThumbnailUrl() {
    return this.entry && this.entry['thumbnail-url'];
  }

  isStreamlineThumbnail() {
    const thumbnailUrl = this.getThumbnailUrl();

    return !!(thumbnailUrl && this.STREAMLINE_URI.test(thumbnailUrl));
  }

  isDefaultThumbnail() {
    const thumbnailUrl = this.getThumbnailUrl();

    return !!(thumbnailUrl && thumbnailUrl.startsWith(this.DEFAULT_URI));
  }

  getStreamlineIcon() {
    return this.isStreamlineThumbnail() ?
      this.getThumbnailUrl().match(this.STREAMLINE_URI)[1] : '';
  }

  removeFileFromList() {
    this.removeEvent.emit(this.entry);
  }

  editWithCanva() {
    if (this.entry.file) {
      this.componentsService.editComponent({
        type: 'rise-canva',
      }, {
        source: this.entry.file
      });
    }
  }

}
